import { render, staticRenderFns } from "./Dataset_v2.vue?vue&type=template&id=1d38d448&scoped=true&"
import script from "./Dataset_v2.vue?vue&type=script&lang=js&"
export * from "./Dataset_v2.vue?vue&type=script&lang=js&"
import style0 from "./Dataset_v2.vue?vue&type=style&index=0&id=1d38d448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38d448",
  null
  
)

export default component.exports